import Clarity from '@microsoft/clarity';
import {ClarityEventEnum} from 'main/analytics/clarityEventEnum';

export const useClarity = () => {
	const handleClarityEvent = (event: ClarityEventEnum) => {
		try {
			if (!Clarity || typeof Clarity.event !== 'function') {
				return;
			}
			Clarity.event(event);
		} catch {
			return;
		}
	};

	return {
		clarity: Clarity,
		clarityEvent: ClarityEventEnum,
		handleClarityEvent,
	};
};
